/* eslint-disable no-console */
export const log = (messages) => {
  if (
    messages !== null && typeof messages !== "undefined"
    && process.env.NODE_ENV !== "production"
    && process.env.NODE_ENV !== "staging"
  ) {
    const date = new Date();
    const time = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getTime()}`;
    if (Object.prototype.hasOwnProperty.call(messages, "title")) {
      console.group(messages.title, "@ " + time);
      console.log(messages);
      console.groupEnd();
    } else {
      console.group(time);
      console.log(messages);
    }
  }
};

export const setDebugStatus = () => {
  if (process.env.VUE_APP_LOCAL_SERVER === "true") {
    return true;
  }
  if (process.env.VUE_APP_DEPLOYMENT_STAGE === "development") {
    return true;
  }
  return false;
};

